module.exports = __webpack_public_path__ + "img/app_phone1.898ae61e.png";